export default function PowderDashIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="pd-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2F7FF0" />
          <stop offset="1" stopColor="#BFE4FF" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="12" fill="url(#pd-sky)" />
      <path d="M-2 40L14 22L24 32L36 18L66 42V64H-2Z" fill="#B9CDEB" />
      <path d="M14 22L18 27L14 26L11 28ZM36 18L41 24L36 23L32 25Z" fill="#fff" />
      <path d="M0 64V46Q30 36 64 52V64Z" fill="#F4F8FF" />
      <path d="M50 44L56 34L62 44Z" fill="#1F7A4D" />
      <path d="M51 38L56 30L61 38Z" fill="#2E9A66" />
      <path d="M53 33L56 28L59 33Z" fill="#fff" />
      <path d="M4 50L9 41L14 50Z" fill="#25895A" />
      <path d="M6 45L9 39L12 45Z" fill="#fff" />
      <path d="M6 58L20 50L22 54Z" fill="#B8834A" />
      <path d="M8 58Q4 60 10 61" stroke="#AFC3E6" strokeWidth="2" fill="none" />
      <g transform="rotate(-18 34 36)">
        <rect x="20" y="40" width="26" height="5" rx="2.5" fill="#D9302A" stroke="#2A2F45" strokeWidth="1.5" />
        <path d="M44 40q6 0 4 -6" stroke="#D9302A" strokeWidth="3" fill="none" strokeLinecap="round" />
        <rect x="27" y="28" width="11" height="13" rx="5" fill="#E8443A" stroke="#2A2F45" strokeWidth="1.5" />
        <circle cx="34" cy="23" r="6" fill="#FFD0B0" stroke="#2A2F45" strokeWidth="1.5" />
        <path d="M28 22a6 6 0 0 1 12 0Z" fill="#2F6BFF" stroke="#2A2F45" strokeWidth="1.5" />
        <circle cx="34" cy="15.5" r="2.4" fill="#fff" stroke="#2A2F45" strokeWidth="1.2" />
        <circle cx="36.5" cy="24" r="1" fill="#2A2F45" />
        <path d="M28 30l-8 2" stroke="#FFD23F" strokeWidth="3" strokeLinecap="round" />
        <path d="M37 33l7 4" stroke="#E8443A" strokeWidth="3.5" strokeLinecap="round" />
      </g>
      <circle cx="12" cy="10" r="1.5" fill="#fff" />
      <circle cx="24" cy="6" r="1.2" fill="#fff" />
      <circle cx="50" cy="12" r="1.5" fill="#fff" />
      <rect x="44" y="50" width="9" height="8" rx="1.5" fill="#FF3D6E" />
      <rect x="47.5" y="50" width="2" height="8" fill="#FFD54A" />
      <rect x="43.5" y="49" width="10" height="2.5" rx="1" fill="#FF6B8F" />
    </svg>
  );
}
